module.exports = __webpack_public_path__ + "img/sty_1.92f8f169.webp";